export const DEMO_TICKET_STATUS = [
  {
    id: '',
    name: 'Tất cả trạng thái',
  },
  {
    id: 0,
    name: 'Bật',
  },
  {
    id: 1,
    name: 'Tắt',
  },
];

export function getTicketStatus(status) {
  const ticketStatus = DEMO_TICKET_STATUS.find((item) => item.id === status);
  return ticketStatus ? ticketStatus.name : 'Unknown';
}
